import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
import CONFIG from "@/assets/js/config.js";
import axios from 'axios';
import ValidationService from '@/services/ValidationService';

export default {
  name: "ItemList",
  components: {
    MainLayout,
    Loading,
    CONFIG,
    flatPickr,
    AdvancedLaravelVuePaginate,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      itemData: {},
      total: null,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      searchData: [],
      searchedData: null,
      isSearched: false,
    };
  },

  methods: {
    getItem(page = 1) {
      axios.get('item/list?page=' + page)
        .then(res => {
          if (res.data) {
            this.itemData = res.data;
            this.total = this.itemData.meta.total;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    search(page = 1) {
      this.clearValidationErrors();
      this.isLoading = true;
      const params = {
        itemName: this.searchData.itemName,
        fromAmt: this.searchData.fromAmt,
        toAmt: this.searchData.toAmt
      }
      this.searchedData = {
        ...this.searchData
      }
      this.isSearched = true;
      axios.get('item/search?page=' + page, { params })
        .then((res) => {
          this.isLoading = false;
          if (res.data) {
            this.itemData = res.data;
            this.total = this.itemData.meta.total;
          }
        }).catch(error => {
          this.printValidationError(error.response);
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.searchData = [];
      this.isLoading = true;
      this.getItem();
      this.isSearched = false;
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {};
      axios.get('/item/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `payment_item_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    filterAmount(field) {
      let value = this.searchData[field];

      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');

      this.searchData[field] = value ? parseInt(value) : null;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getItem();
  },
};
